import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Creators } from './duck/actions';

import adTissot from '../../assets/images/ad-tissot.png';
import adSuggested from '../../assets/images/ad-suggested.png';

// import Banner from '../common/Banner/Banner';
import AdBanner from '../common/AdBanner/AdBanner';
import ArticleList from '../common/ArticleList/ArticleList';
import OuterBox from '../common/OuterBox/OuterBox';
import InnerBox from '../common/InnerBox/InnerBox';

import { ListElement, Image, FlexContainer } from '../common/StyledComponents';
import { SideBar } from '../common/StyledComponents/StyledSideBar';

import adAmazon from '../../assets/images/ad-amazon.png';
import adSuggestedVertical from '../../assets/images/ad-suggested-vertical.png';
import adAmazonVertical from '../../assets/images/ad-amazon-vertical.png';
import AuthorInfo from './AuthorInfo';

class Author extends Component {
  componentWillMount = () => {
    // console.log('[Author.js] componentWillMount');
    window.scrollTo(0, 0);
  };

  componentDidMount = () => {
    // console.log('this.props: ', this.props);
    // console.log('this.props.history: ', this.props.history);
    this.props.onFetchAuthorInfo(this.props.history.location.pathname.slice(8));
    this.props.onFetchAuthorPosts(
      this.props.history.location.pathname.slice(8),
      1
    );
  };

  handlePageChange = page => {
    this.props.onFetchAuthorPosts(
      this.props.history.location.pathname.slice(8),
      page
    );
  };

  navigateAndIncreasePostCount = (postId, postSlug) => {
    // console.log('postId: ', postId);
    // console.log('postSlug: ', postSlug);
    // this.props.onIncreasePostCount(postId);
    this.navigate(postSlug);
  };

  navigate = postSlug => {
    // console.log('postSlug: ', postSlug);
    this.props.history.push(`/${postSlug}`);
  };

  render() {
    const dataForArticleList = {
      limit: 1,
      pageCount: 8,
      total: 18,
      currentPage: 1
    };

    const { authorData, authorPosts } = this.props;

    return (
      <div className="News">
        <AdBanner height="250px" width="970px" margin="1rem 0 0 0">
          <Image src={adTissot} width="100%" height="100%" alt="tissot ad" />
        </AdBanner>

        <OuterBox>
          <InnerBox>
            <FlexContainer direction="column" className="left-half">
              {authorData ? <AuthorInfo {...authorData} /> : null}
              {authorPosts ? (
                <ArticleList
                  title="Author's Posts"
                  data={dataForArticleList}
                  contentData={authorPosts}
                  handlePageChange={this.handlePageChange}
                  clicked={this.navigateAndIncreasePostCount}
                />
              ) : null}
            </FlexContainer>
            <SideBar>
              <AdBanner height="250px" width="300px" margin="0 0 1rem 0">
                <Image
                  src={adAmazon}
                  width="100%"
                  height="100%"
                  alt="tissot ad"
                />
              </AdBanner>

              <AdBanner height="565px" width="300px" margin="0.5rem 0">
                <Image
                  src={adSuggestedVertical}
                  width="100%"
                  height="100%"
                  alt="tissot ad"
                />
              </AdBanner>

              <AdBanner height="600px" width="300px" margin="18px 0 18px 0">
                <Image
                  src={adAmazonVertical}
                  width="100%"
                  height="100%"
                  alt="tissot ad"
                />
              </AdBanner>
            </SideBar>
          </InnerBox>
        </OuterBox>

        <AdBanner height="250px" width="970px" margin="0">
          <Image src={adTissot} width="100%" height="100%" alt="tissot ad" />
        </AdBanner>

        <OuterBox>
          <InnerBox>
            <ListElement className="w-100" maxwidth="100%" padding="20px">
              {/* <Title
                fontFamily="Montserrat"
                fontSize="1.5rem"
                fontWeight="bold"
              >
                Suggested
              </Title>
              <StyledLine>
                <StyledLineInside />
              </StyledLine> */}
              {/* <AdBanner height="210px" width="1000px" margin="0"> */}
              <AdBanner height="346px" width="1040px" margin="0">
                <Image
                  src={adSuggested}
                  width="100%"
                  height="100%"
                  alt="tissot ad"
                />
              </AdBanner>
            </ListElement>
          </InnerBox>
        </OuterBox>
      </div>
    );
  }
}

const mapStateToProps = state => {
  // console.log('state.authorInfo: ', state.authorInfo);
  return {
    loading: state.authorInfo.loading,
    authorData: state.authorInfo.authorData,
    authorPosts: state.authorInfo.authorPosts
  };
};

const mapDispatchToProps = dispatch => ({
  onFetchAuthorInfo: authorName =>
    dispatch(Creators.fetchAuthorInfo(authorName)),
  onFetchAuthorPosts: (authorName, page) =>
    dispatch(Creators.fetchAuthorPosts(authorName, page))
  // onIncreasePostCount: postId => dispatch(Creators.increasePostCount(postId))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Author);
